import { render, staticRenderFns } from "./ComandoVelocidad.vue?vue&type=template&id=1ada678d&"
import script from "./ComandoVelocidad.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports